import { useSnapshot } from 'valtio';
import { modalsState } from './state';
import { ModalFactory } from './ModalFactory';

export const ModalsGroup = () => {
  const { activeModalId, props } = useSnapshot(modalsState);

  if (!activeModalId) return null;

  const ModalComponent = ModalFactory[activeModalId];
  if (!ModalComponent) return null;

  return ModalComponent(props);
};
